export default __webpack_public_path__ + "static/media/uploader-animas-1.633ee8d0.png";